
<template>
  <div>
<!--     <lazy-component> -->
      <div class="imageloader-background" v-bind:class=" { 'active': !imgLoaded } "></div>
      <img 
        ref="myImg" 
        :src="'static/img/content/'+ imgSrc" 
        @load="thisLoaded()" 
        class="imageloader-image"
        :style=" { 'opacity': imgOpacity + '!important' } "
      />
<!--     </lazy-component> -->
    <!-- <div class="image-loader2" v-if="!imgLoaded"> -->
     <!--  <div class="image-loader-shadow"></div>
      <div class="image-loader-square"></div>
      <div class="image-loader-bar image-loader-bar-1"></div>
      <div class="image-loader-bar image-loader-bar-2"></div>
      <div class="image-loader-bar image-loader-bar-3"></div> -->
  </div>
</template>

<style scoped>

.image-loader2 {
  position: absolute;
  width:1%;
  height:10px;
  left: 0%;
  top: 50%;
  border-radius: 0px;
  -webkit-transform:translate3d(0%, -50%, 0);
  transform:translate3d(0%, -50%, 0);
  background-color: #ec7d8d;
  animation: grow-loader 3s infinite;
  -webkit-animation: grow-loader 3s infinite;
  transform-origin: 0%;
  -webkit-transform-origin: 0%;
}

@keyframes grow-loader {
  0%   { width: 0; }
  100%   { width: 100%; }
}
@-webkit-keyframes grow-loader {
  0%   { width: 0; }
  100%   { width: 100%; }
}

.image-loader {
  position: absolute;
  width:70px;
  height:30px;
  -webkit-transform: translate3d(-50%, -50%, 0);
  left: 50%;
  top: 50%;
}

.image-loader-square {
  position: absolute;
  background-color: rgba(255,255,255, 1);
  transform-origin: 50% 50%;
  -webkit-transform-origin: 50% 50;
  animation: loader-square-one 3s infinite;
  -webkit-animation: loader-square-one 3s infinite;
  border: 1px solid #d1a699;
}

.image-loader-shadow {
  position: absolute;
  background-color: #ec7d8d;
  transform-origin: 50% 50%;
  -webkit-transform-origin: 50% 50;
  animation: loader-shadow-one 3s infinite;
  -webkit-animation: loader-shadow-one 3s infinite;
}
.imageloader-background {
  position: absolute;
  width: 100%;
  height:100%;
  background-color: #fefefe;
    transition: 0.6s;
  -webkit-transition: 0.6s;
  opacity: 0;
}


.image-loader-bar {
  position: absolute;
  background-color: #d1a699;
  z-index: 2;
  width: 50px;
  height: 5px;
}
.image-loader-bar-1 {
  animation: loader-bar-one 3s infinite;
  -webkit-animation: loader-bar-one 3s infinite;
  transform-origin: 0% 0%;
}
.image-loader-bar-2 {
  animation: loader-bar-two 3s infinite;
  -webkit-animation: loader-bar-two 3s infinite;
}
.image-loader-bar-3 {
  animation: loader-bar-three 3s infinite;
  -webkit-animation: loader-bar-three 3s infinite;
}

@keyframes loader-square-one {
  0%   { transform: translate3d(20px, 0, 0) rotateZ(0); height: 29px; width: 30px; }
  10%   { transform: translate3d(20px, 0, 0) rotateZ(0); height: 29px; width: 30px; }
  60%   { transform: translate3d(0px, 0, 0) rotateZ(0); height: 29px; width: 70px; }
  80%   { transform: translate3d(0px, 0, 0) rotateZ(0); height: 29px; width: 70px; }
  100%   { transform: translate3d(20px, 0, 0) rotateZ(360deg); height: 29px; width: 30px; }
}
@-webkit-keyframes loader-square-one {
  0%   { -webkit-transform: translate3d(20px, 0, 0) rotateZ(0); height: 29px; width: 30px; }
  10%   { -webkit-transform: translate3d(20px, 0, 0) rotateZ(0); height: 29px; width: 30px; }
  60%   { -webkit-transform: translate3d(0px, 0, 0) rotateZ(0); height: 29px; width: 70px; }
  80%   { -webkit-transform: translate3d(0px, 0, 0) rotateZ(0); height: 29px; width: 70px; }
  100%   { -webkit-transform: translate3d(20px, 0, 0) rotateZ(360deg); height: 29px; width: 30px; }
}
@keyframes loader-shadow-one {
  0%   { transform: translate3d(25px, 5px, 0) rotateZ(0); height: 29px; width: 30px; }
  10%   { transform: translate3d(25px, 5px, 0) rotateZ(0); height: 29px; width: 30px; }
  60%   { transform: translate3d(5px, 5px, 0) rotateZ(0); height: 29px; width: 70px; }
  80%   { transform: translate3d(5px, 5px, 0) rotateZ(0); height: 29px; width: 70px; }
  100%   { transform: translate3d(25px, 5px, 0) rotateZ(360deg); height: 29px; width: 30px; }
}
@-webkit-keyframes loader-shadow-one {
  0%   { -webkit-transform: translate3d(25px, 5px, 0) rotateZ(0); height: 29px; width: 30px; }
  10%   { -webkit-transform: translate3d(25px, 5px, 0) rotateZ(0); height: 29px; width: 30px; }
  60%   { -webkit-transform: translate3d(5px, 5px, 0) rotateZ(0); height: 29px; width: 70px; }
  80%   { -webkit-transform: translate3d(5px, 5px, 0) rotateZ(0); height: 29px; width: 70px; }
  100%   { -webkit-transform: translate3d(25px, 5px, 0) rotateZ(360deg); height: 29px; width: 30px; }
}

@keyframes loader-bar-one {
  0%   { transform: translate3d(7px, 7px, 0) rotateZ(0); height: 1px; width: 0px; }
  40%   { transform: translate3d(7px, 7px, 0) rotateZ(0); height: 1px; width: 0px; }
  60%   { transform: translate3d(7px, 7px, 0) rotateZ(0); height: 1px; width: 56px; }
  70%   { transform: translate3d(63px, 7px, 0) rotateZ(0); height: 1px; width: 0px; }
  100%   { transform: translate3d(0px, 7px, 0) rotateZ(0); height: 1px; width: 0px; }
}

@keyframes loader-bar-two {
  0%   { transform: translate3d(7px, 14px, 0) rotateZ(0); height: 1px; width: 0px; }
  45%   { transform: translate3d(7px, 14px, 0) rotateZ(0); height: 1px; width: 0px; }
  60%   { transform: translate3d(7px, 14px, 0) rotateZ(0); height: 1px; width: 56px; }
  75%   { transform: translate3d(63px, 14px, 0) rotateZ(0); height: 1px; width: 0px; }
  100%   { transform: translate3d(0px, 14px, 0) rotateZ(0); height: 1px; width: 0px; }
}

@keyframes loader-bar-three {
  0%   { transform: translate3d(7px, 21px, 0) rotateZ(0); height: 1px; width: 0px; }
  50%   { transform: translate3d(7px, 21px, 0) rotateZ(0); height: 1px; width: 0px; }
  60%   { transform: translate3d(7px, 21px, 0) rotateZ(0); height: 1px; width: 56px; }
  80%   { transform: translate3d(63px, 21px, 0) rotateZ(0); height: 1px; width: 0px; }
  100%   { transform: translate3d(0px, 21px, 0) rotateZ(0); height: 1px; width: 0px; }
}

@-webkit-keyframes loader-bar-one {
  0%   { -webkit-transform: translate3d(7px, 7px, 0) rotateZ(0); height: 1px; width: 0px; }
  40%   { -webkit-transform: translate3d(7px, 7px, 0) rotateZ(0); height: 1px; width: 0px; }
  60%   { -webkit-transform: translate3d(7px, 7px, 0) rotateZ(0); height: 1px; width: 56px; }
  70%   { -webkit-transform: translate3d(63px, 7px, 0) rotateZ(0); height: 1px; width: 0px; }
  100%   { -webkit-transform: translate3d(0px, 7px, 0) rotateZ(0); height: 1px; width: 0px; }
}

@-webkit-keyframes loader-bar-two {
  0%   { -webkit-transform: translate3d(7px, 14px, 0) rotateZ(0); height: 1px; width: 0px; }
  45%   { -webkit-transform: translate3d(7px, 14px, 0) rotateZ(0); height: 1px; width: 0px; }
  60%   { -webkit-transform: translate3d(7px, 14px, 0) rotateZ(0); height: 1px; width: 56px; }
  75%   { -webkit-transform: translate3d(63px, 14px, 0) rotateZ(0); height: 1px; width: 0px; }
  100%   { -webkit-transform: translate3d(0px, 14px, 0) rotateZ(0); height: 1px; width: 0px; }
}

@-webkit-keyframes loader-bar-three {
  0%   { -webkit-transform: translate3d(7px, 21px, 0) rotateZ(0); height: 1px; width: 0px; }
  50%   { -webkit-transform: translate3d(7px, 21px, 0) rotateZ(0); height: 1px; width: 0px; }
  60%   { -webkit-transform: translate3d(7px, 21px, 0) rotateZ(0); height: 1px; width: 56px; }
  80%   { -webkit-transform: translate3d(63px, 21px, 0) rotateZ(0); height: 1px; width: 0px; }
  100%   { -webkit-transform: translate3d(0px, 21px, 0) rotateZ(0); height: 1px; width: 0px; }
}


.imageloader-image {
  transition: 0.6s;
  -webkit-transition: 0.6s;
}
.imageloader-image.active {

}
.imageloader-background.active {
  opacity: 1;
}

</style>

<script>
export default {
  props: ['imgSrc'],
  data: function () {
    return {
      imgLoaded: false,
      imgOpacity: 0
    }
  },
  methods: {
    handler () {
    },
    thisLoaded () {
      this.$nextTick(() => {
        this.imgLoaded = true
        this.imgOpacity = 1
      })
    }
  },
  mounted: function () {
    this.imgOpacity = 0
  }
}
</script>



// WEBPACK FOOTER //
// ImageLoader.vue?119ca1f8